module.exports = __webpack_public_path__ + "static/media/intro-photowall-31.ad226d1d.jpg";